import Vue from 'vue'
import store from '@/store'
import lstore from '@/lib/store'
import { jiminnyHost } from '@/helpers/region'
import NotificationsPlugin from 'vue-components/notifications'
import defaultAvatar from '@/assets/img/default-avatar.svg'

Vue.use(NotificationsPlugin, {
  store,
  jiminnyHost,
  openLinksInNewWindow: true,
  defaultAvatarUrl: defaultAvatar,
  getUserId () {
    return lstore.get('user').id
  },
  hostApp: 'extension-app'
})



// WEBPACK FOOTER //
// ./src/plugins/notifications.js